import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import { taskStore } from './taskStore';

const useTaskStore = createStore({
  creator: taskStore({
    useDashboardStore: lazyDependency(() => useDashboardStore),
  }),
  id: 'task',
  middlewares: {
    devtools: true,
  },
});

export default useTaskStore;
